import { api } from '@/api/index'
function getColor(): string[] {
  const color = [
    '#0071FF',
    '#FF9900',
    '#62D599',
    '#EB569B',
    '#BB00BB',
    '#8397BC',
    '#E86452',
    '#FFCC0D',
    '#5010D5'
  ]
  // ['#0071FF', '#FFB900', '#00D894', '#FF469D', '#00D2FF', '#A164EA', '#7E98BF', '#FF332B']
  return color
}

function getNumber(number: number): string {
  let num: any = number
  num =
    Math.abs(num) >= 1000000000000
      ? (num / 1000000000000).toFixed(2) + '万亿'
      : Math.abs(num) >= 100000000
        ? (num / 100000000).toFixed(2) + '亿'
        : Math.abs(num) >= 10000
          ? (num / 10000).toFixed(2) + '万'
          : parseFloat(num).toString() !== 'NaN'
            ? num
            : num || '—'
  return String(num)
}
function getPencent(number: number): string {
  let num: any = number
  num = parseFloat(num).toString() !== 'NaN' ? num.toFixed(2) + '%' : '—'
  return String(num)
}
function getNumber1(number: number): string {
  if (!number) return '—'
  // 大于等于10000，换算成以"万"为单位，保留一位小数；小于10000不换算，保留一位小数
  let num: any = number
  if (parseFloat(num).toString() === 'NaN') {
    return num ? num.toFixed(1) : '—'
  }
  num = Math.abs(num) >= 10000 ? (num / 10000).toFixed(1) + '万' : num
  return String(num)
}
function getNumber2(number: number): string {
  if (!number) return '—'
  // 亿万千，保留两位小数
  let num: any = number
  num =
    Math.abs(num) >= 1000000000000
      ? (num / 1000000000000).toFixed(2) + '万亿'
      : Math.abs(num) >= 100000000
        ? (num / 100000000).toFixed(2) + '亿'
        : Math.abs(num) >= 10000
          ? (num / 10000).toFixed(2) + '万'
          : parseFloat(num).toString() !== 'NaN'
            ? num.toFixed(2)
            : num
              ? num.toFixed(2)
              : '—'
  return String(num)
}
function getNumber3(number: number): string {
  // 亿万千，保留两位小数
  let num: any = number
  num =
    Math.abs(num) >= 1000000000000
      ? (num / 1000000000000).toFixed(2) + '万亿'
      : Math.abs(num) >= 100000000
        ? (num / 100000000).toFixed(2) + '亿'
        : Math.abs(num) >= 10000
          ? (num / 10000).toFixed(2) + '万'
          : parseFloat(num).toString() !== 'NaN'
            ? num.toFixed(3)
            : num
              ? num.toFixed(3)
              : '—'
  return String(num)
}

// 美股最新价格式化：>=1显示2位小数，<1显示4位小数
function getUSPrice(number: number): string {
  if (number === null || number === undefined || isNaN(number)) return '—'
  return number >= 1 ? number.toFixed(2) : number.toFixed(4)
}

// 美股涨跌格式化：根据最新价精度动态调整
function getUSChange(number: number, price: number): string {
  if (number === null || number === undefined || isNaN(number)) return '—'
  // 根据价格确定精度：>=1显示2位小数，<1显示4位小数
  return price >= 1 ? number.toFixed(2) : number.toFixed(4)
}

// 美股涨跌幅格式化：带百分号，2位小数
function getUSChangePercent(number: number): string {
  if (number === null || number === undefined || isNaN(number)) return '—'
  return number.toFixed(2) + '%'
}

// 港股最新价格式化：3位小数
function getHKPrice(number: number): string {
  if (number === null || number === undefined || isNaN(number)) return '—'
  return number.toFixed(3)
}

// 港股涨跌格式化：3位小数
function getHKChange(number: number): string {
  if (number === null || number === undefined || isNaN(number)) return '—'
  return number.toFixed(3)
}

// 港股涨跌幅格式化：带百分号，2位小数
function getHKChangePercent(number: number): string {
  if (number === null || number === undefined || isNaN(number)) return '—'
  return number.toFixed(2) + '%'
}
function getNumberNoUnit2(number: number): string {
  if (!number) return '—'
  // 不进行单位换算，只保留两位小数
  let num: any = number
  num = parseFloat(num).toString() !== 'NaN' ? num.toFixed(2) : num ? num.toFixed(2) : '—'
  return String(num)
}
function formatTime(date: number): string {
  /*
    时间 < 15分钟            刚刚
    15分钟<= 时间< 60分钟    35 分钟前
    1小时<= 时间 <  24小时   3 小时前
    时间 >= 24小时           显示年月日时分，使用 yyyy-MM-dd HH:mm 格式
  */
  if (!date) return '-'
  const target = window.moment(date * 1000)
  const after24H = window.moment().subtract(24, 'hours')
  const after1H = window.moment().subtract(1, 'hour')
  const after15m = window.moment().subtract(15, 'minutes')
  if (target.isAfter(after15m)) {
    return '刚刚'
  } else if (target.isBetween(after1H, after15m)) {
    return '35分钟前'
  } else if (target.isBetween(after24H, after1H)) {
    return '3小时前'
  } else {
    return target.format('YYYY-MM-DD HH:mm')
  }
}
// 获取季度
function setquarter(date: number): string {
  const q = window.moment(date).quarter()
  let str = ''
  switch (q) {
    case 1:
      str = '一'
      break
    case 2:
      str = '二'
      break
    case 3:
      str = '三'
      break
    case 4:
      str = '四'
      break
  }
  return str
}
// 获取token
function getToken(): any {
  return api.getToken().then((res: any) => {
    return res.Data.Token
  })
}
// 校验输入的是数值，且最多有两位小数
function filterNumberAndDot(num: number): number {
  let value: any = num.toString()
  value = value
    .replace(/[^\d.]/g, '') // 将非数字和点以外的字符替换成空
    .replace(/^\./g, '') // 验证第一个字符是数字而不是点
    .replace(/\.{2,}/g, '.') // 出现多个点时只保留第一个
    .replace('.', '$#$') // 1、将数字的点替换成复杂字符$#$
    .replace(/\./g, '') // 2、将字符串的点直接清掉
    .replace('$#$', '.') // 3、将复杂字符再转换回点
    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
  if (value.indexOf('.') < 0 && value !== '') {
    value = parseFloat(value)
  } else if (value.indexOf('.') > 1 && value[0] === '0') {
    value = parseFloat(value)
  }
  return value
}
export default {
  getColor,
  getNumber,
  getPencent,
  getNumber1,
  getNumber2,
  getNumber3,
  getUSPrice,
  getUSChange,
  getUSChangePercent,
  getHKPrice,
  getHKChange,
  getHKChangePercent,
  getNumberNoUnit2,
  formatTime,
  setquarter,
  getToken,
  filterNumberAndDot
}
